<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">Inland Cost:</p>
            <a href="#" class="card-header-icon">
              <span class="icon has-text-danger">
                <i class="fas fa-truck"></i>
              </span>
            </a>
        </header>
        <div class="">
            <div class="content center inland-container">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Yokohama/Kawasaki:</th>
                        <th>Osaka/Kobe:</th>
                        <th>Nagoya:</th>
                        <th>Hakata:</th>
                    </tr>
                    <tr>
                        <td class="has-text-primary">{{ yokohama }}</td>
                        <td class="has-text-primary">{{ osaka }}</td>
                        <td class="has-text-primary">{{ nagoya }}</td>
                        <td class="has-text-primary">{{ hakata }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInlandPrice from './../../../../api/apiInlandPrice'
    import numeral from 'numeral'
    export default {
        data() {
            return {
                yokohama: '',
                osaka: '',
                nagoya: '',
                hakata: '',
                query: {
                    auction: this.$store.getters.getResultActiveBiddingModalLot.auction_name
                }
            }
        },
        methods: {
            getPriceNumber(value) {
                return value !== null ? numeral(value).format("0,0") : 'NaN'
            }
        },
        created() {
            apiInlandPrice
                .requestAuctionDeliveryPrices(this.query)
                .then((response) => {
                    this.yokohama = response.data.yokohama_sales
                    this.osaka = response.data.osaka_sales
                    this.nagoya = response.data.nagoya_sales
                    this.hakata = response.data.hakata_sales
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/BiddingModal/InlandCost.vue